import { render, staticRenderFns } from "./CardStatsV6.vue?vue&type=template&id=74d6b69d&scoped=true&"
import script from "./CardStatsV6.vue?vue&type=script&lang=js&"
export * from "./CardStatsV6.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV6.vue?vue&type=style&index=0&id=74d6b69d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6b69d",
  null
  
)

export default component.exports